import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/openService',
    name: 'openService',
    component: () => import('../pages/openService/index.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/',
    redirect: '/openService',
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
